import { Heading } from "@mittwald/flow-remote-react-components";
import { useAppInstallationPHPStatistics } from "../hooks/useAppInstallationPHPStatistics.ts";
import { ProgressBar } from "@mittwald/flow-remote-react-components";
import { Text } from "@mittwald/flow-remote-react-components";
import { Header } from "@mittwald/flow-remote-react-components";
import {
  ContextualHelp,
  ContextualHelpTrigger,
} from "@mittwald/flow-remote-react-components";
import { Button } from "@mittwald/flow-remote-react-components";
import { Link } from "@mittwald/flow-remote-react-components";
import { Modal } from "@mittwald/flow-remote-react-components";
import { IconDelete } from "@mittwald/flow-remote-react-components";
import { Content } from "@mittwald/flow-remote-react-components";
import { Section } from "@mittwald/flow-remote-react-components";
import { ActionGroup } from "@mittwald/flow-remote-react-components";
import { Action } from "@mittwald/flow-remote-react-components";
import { Label } from "@mittwald/flow-remote-react-components";
import { Flex } from "@mittwald/flow-remote-react-components";
import { useResetOPcache } from "../hooks/useResetOPcache.ts";
export const OPcacheStats = (props: {
  projectId: string;
  appInstallationId: string;
}) => {
  const phpStats = useAppInstallationPHPStatistics(
    props.projectId,
    props.appInstallationId,
  );

  const resetOPCacheMutation = useResetOPcache(
    props.projectId,
    props.appInstallationId,
  );

  return (
    <>
      <Header>
        <Heading level={3}>
          OPcache
          <ContextualHelpTrigger>
            <Button />
            <ContextualHelp>
              <Heading>OPcache</Heading>
              <Text>
                OPcache steigert die PHP-Performance, indem es den
                vorkompilierten Bytecode im Arbeitsspeicher ablegt. Dadurch
                entfällt das erneute Laden und Parsen der Skripte bei jedem
                einzelnen Request.
              </Text>
              <Link
                href="https://www.php.net/manual/de/book.opcache.php"
                target="_blank"
              >
                Mehr erfahren
              </Link>
            </ContextualHelp>
          </ContextualHelpTrigger>
        </Heading>
        <Action onAction={() => resetOPCacheMutation.mutateAsync()}>
          <Modal size="s" slot="actionConfirm">
            <Heading>
              <Flex
                elementType="span"
                direction="row"
                align="center"
                justify="center"
                gap="s"
              >
                <IconDelete />
                Möchtest du den OPcache wirklich leeren?
              </Flex>
            </Heading>
            <Content>
              <Section>
                <Text>
                  Das Leeren des OPcache sorgt initial für einen verlängerten
                  Seitenaufruf.
                </Text>
              </Section>
            </Content>
            <ActionGroup>
              <Button color="danger">OPcache leeren</Button>
              <Button variant="soft" color="secondary">
                Abbrechen
              </Button>
            </ActionGroup>
          </Modal>
          <Button color="danger" variant="soft">
            OPcache leeren
          </Button>
        </Action>
      </Header>
      <ProgressBar
        value={phpStats.data.opcache?.usage ?? 0}
        maxValue={phpStats.data.opcache?.size ?? 0}
        showMaxValue
        formatOptions={{ style: "unit", unit: "megabyte" }}
      >
        <Label>Aktuelle OPcache-Auslastung</Label>
      </ProgressBar>
    </>
  );
};
